import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { Page } from '@connected/ui/features/layouts';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { HeaderNavigation } from '@/components/navigation/header-navigation';

export const Route = createFileRoute(
    '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId',
)({
    component: Layout,
    loader: ({ context, params }) => {
        context.queryClient.ensureQueryData(elektraAppQueryOptions.project.inspection.finalCircuit.finalCircuitOptions({
            electricalProjectFinalCircuitId: params.finalCircuitId,
        }));
    },
});

function Layout() {
    const params = Route.useParams();
    const search = Route.useSearch();

    const { data } = useQuery(
        elektraAppQueryOptions.project.inspection.finalCircuit.finalCircuitOptions({
            electricalProjectFinalCircuitId: params.finalCircuitId,
        }),
    );

    return (
        <Page>
            <Page.Header>
                <Page.Header.Bar>
                    <Page.Header.Back
                        to="/projects/$projectVersionId/re-inspections/final-circuits"
                        params={params}
                        search={search}
                    />
                    <Page.Header.Title>
                        {data?.Circuit?.Identifier
                            || 'Naamloze achterliggende installatie'}
                    </Page.Header.Title>
                </Page.Header.Bar>
                <HeaderNavigation />
            </Page.Header>
            <Page.Outlet />
        </Page>
    );
}
